<form [formGroup]="formName">
    <mat-form-field class="w-100">
        <mat-label>{{ field.label }}</mat-label>
        <input
            matInput
            type="text"
            matTooltipClass="custom-tooltip"
            [formControlName]="field.name || ''"
            [matTooltip]="field.tooltipMessage || ''"
            [readonly]="field.isDisabled"
            [imask]="maskOptions"
            (blur)="fileInput?.markAsTouched()"
            [placeholder]="field.placeholder || field.label || ''"
        />
        @if (field.hint && field.hint.length > 0) {
            <mat-hint>{{ field.hint }}</mat-hint>
        }
        <mat-error>
            <app-dynamic-error [field]="field" />
            @if (field.hint && field.hint.length > 0) {
                <span class="hint">{{ field.hint }}</span>
            }
        </mat-error>
    </mat-form-field>
</form>
